import { P2GTextField } from '@parcel2go/core-ui';
import { useEffect, useState } from 'react';

interface props {
  onChange: (value: string, valid: boolean) => Promise<void> | void;
  onValid?: (value: string) => Promise<void> | void;
  onInvalid?: (e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onKeyPress?: (e: React.KeyboardEvent) => void;
  onEnter?: () => void;
  debounceTime?: number;
  name?: string;
  id: string;
  label?: string;
  type?: 'text' | 'email' | 'number' | 'tel' | 'url' | 'search' | 'submit';
  fullWidth?: boolean;
  value: string;
  autoComplete?: string;
  helperText?: string;
  autoFocus?: boolean;
  step?: number;
  inputMode?: 'none' | 'text' | 'decimal' | 'numeric' | 'tel' | 'search' | 'email' | 'url';
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  disabled?: boolean;
  showErrorsWhenPristine?: boolean;
  required?: boolean;
  maxLength?: number;
  minLength?: number;
  pattern?: string;
  min?: number;
  max?: number;
  multiline?: boolean;
  rows?: number;
  rowsMax?: number;
}

export default function DebouncedInput(props: props) {
  const [value, setValue] = useState<string>(props.value ?? '');

  useEffect(() => {
    const handler = setTimeout(() => {
      props.onChange(value, true);
    }, props.debounceTime ?? 500);

    return () => {
      clearTimeout(handler);
    };
  }, [value, props.debounceTime]);

  return (
    <P2GTextField
      fullWidth
      {...props}
      onChange={(v) => setValue(v.currentTarget.value)}
      onKeyPress={(e) => {
        if (props.onKeyPress) {
          props.onKeyPress(e);
        }
        if (props.onEnter && e.key === 'Enter') {
          props.onEnter();
        }
      }}
      value={value}
    />
  );
}
